import React, { useState, useEffect } from 'react';

const ToTop = () => {
  const [scrollTop, setScrollTop] = useState(0);

  const handler = () => {
    // 页面滚动距离
    const top = window.scrollY;
    setScrollTop(top);
  };

  useEffect(() => {
    setScrollTop(window.scrollY);
    window.addEventListener('scroll', handler);

    return () => {
      window.removeEventListener('scroll', handler);
    };
  }, []);

  const toTop = () => {
    window.scrollTo({
      left: 0,
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <>
      {scrollTop > 400 && (
        <svg 
          className="btn-to-top fixed z-30 right-30px bottom-80px cursor-pointer" 
          t="1691244430811" 
          viewBox="0 0 1024 1024" 
          version="1.1" 
          xmlns="http://www.w3.org/2000/svg" 
          width="50" 
          height="50" 
          onClick={toTop}
        >
          <path d="M512 512m-512 0a512 512 0 1 0 1024 0 512 512 0 1 0-1024 0Z" fill="#ff525e"></path>
          <path
            d="M784.430545 643.304727c9.588364-9.402182 8.285091-23.552-2.885818-31.650909l-229.143272-233.890909a30.487273 30.487273 0 0 0-34.676364 0L288.581818 611.653818c-11.170909 8.098909-12.474182 22.248727-2.885818 31.650909a30.254545 30.254545 0 0 0 37.562182 2.466909l211.781818-221.370181 211.781818 221.370181c5.073455 3.630545 11.217455 5.399273 17.361455 5.399273a28.951273 28.951273 0 0 0 20.247272-7.866182z"
            fill="#FFFFFF"
          ></path>
        </svg>
      )}
    </>
  );
};

export default ToTop;